import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const ConfirmationDialog = ({
    open,
    handleClose,
    title,
    message,
    confirmText,
    cancelText,
    showConfirmButton = true,
    showCancelButton = true,
    handleConfirm,
    showSuccessIcon = false // New prop to control icon visibility
}) => {
    console.log("showCancelButton", showCancelButton);

    return (
        <Dialog
            open={open}
            keepMounted
            onClose={handleClose}
            aria-labelledby={title ? "alert-dialog-title" : undefined}
            aria-describedby={message ? "alert-dialog-description" : undefined}
            sx={{
                '& .MuiDialog-container': {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                },
                '& .MuiPaper-root': {
                    margin: 20,
                    maxHeight: '80vh', // Ensure dialog doesn't exceed viewport height
                    display: 'flex',
                    flexDirection: 'column',
                },
            }}
        >
            {/* Conditional rendering of the title */}
            {title && (
                <DialogTitle id="alert-dialog-title" sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    pt: 2,
                    px: 2,
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', }}>
                        {showSuccessIcon && (
                            <CheckCircleIcon sx={{ color: "#6EBE44", marginRight: 1 }} /> // Success Icon
                        )}
                        <Typography variant="h3" component="h3">
                            {title}
                        </Typography>
                    </div>
                    <CloseIcon
                        sx={{ cursor: "pointer", color: "#000000", opacity: "87%" }}
                        onClick={handleClose}
                    />
                </DialogTitle>
            )}

            {/* Conditional rendering of the message */}
            {message && (
                <DialogContent>
                    <Typography id="alert-dialog-description" sx={{ mt: 2 }}>
                        {message}
                    </Typography>
                </DialogContent>
            )}

            <DialogActions sx={{ padding: '8px 24px' }}>
                {/* Conditionally show the Cancel button */}
                {showCancelButton && (
                    <Button className="custombutton" onClick={handleClose} variant="outlined" sx={{ color: 'gray' }}>
                        {cancelText || 'Cancel'}
                    </Button>
                )}
                {/* Conditionally show the Confirm button */}
                {showConfirmButton && (
                    <Button className="custombutton" onClick={handleConfirm} variant="contained" sx={{ background: "#6EBE44", borderColor: "#6EBE44" }}>
                        {confirmText || 'Confirm'}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;
